// extracted by mini-css-extract-plugin
export default {"about":"About_about__1eeQa","contact":"About_contact__CM4Z2","contact__form":"About_contact__form__e82G-","form__group":"About_form__group__u9ecM","submit":"About_submit__uwFr-"};